module.exports = __webpack_public_path__ + "264c7aa5ffd9a987d064e7f73f94fb.svg";